import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Field, reduxForm } from 'redux-form'

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import Divider from '@material-ui/core/Divider';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Carousel from 'nuka-carousel';

import { messageSendRequest, addAttachment, removeAttachment, resetMessage } from '../redux/reducers/message';
import { connectedUsersRequest, selectRecipient } from '../redux/reducers/connectedUsers';
import { toggleComposeMessage, toggleNotification } from '../redux/reducers/view';
import { messageTitle } from '../redux/selectors';

import attach from '../assets/attach.svg';
import { commonStyles, COLORS } from '../styles/styles';
import { getFileType } from '../utils';
import { MDBInput, MDBCard, MDBIcon, MDBCardBody, MDBBtn } from "mdbreact";
import DropdownUsers from './Form/DropdownUsers';
import { messagesListRequest, messagesSentRequest } from '../redux/reducers/messagesList';
const MessageCompose = ({
  classes,
  textAreaField,
  toggleComposeMessage,
  sendTo,
  handlePickSendTo,
  connectedUsers,
  handleTextArea,
  message,
  removeAttachments,
  handleAttachFile,
  handleSend,
  setComposeMessage,
  handleSubject,
  messagesListRequest,
  messagesSentRequest,
  closeCompose
}) => {
  const isDisabled =
    textAreaField === null ||
    textAreaField.length <= 0;
  return (


    <MDBCard  className="z-depth-5 rounded-0 float-right col-lg-6 col-md-6 p-0 fixedCard yellow-card">
     
      <div className='gothamBlack text-dark text-left p-3' onClick={()=>{
          closeCompose();
          }}>
        <MDBIcon icon='times' className="primary-text" size="lg" style={{paddingRight:10}} />
        NEW MESSAGE
      </div>
      <div className='text-dark md-copy text-left p-3 special-color'>
        To:  {connectedUsers.users && 
          <DropdownUsers options={connectedUsers.users} handlePick={handlePickSendTo}/>
        }
      </div>
      <MDBCardBody style={{backgroundColor: '#ffffff'}} className="textarea-label contentScrollList">
        <MDBInput className="md-copy" label="Subject" getValue={handleSubject}/>
        <MDBInput style={{width:'91%'}} className="text-dark md-copy mdb-color lighten-1 md-border-lighten2 text-left mt-4 mb-3 p-4" type="textarea" label="Message" rows="10" getValue={handleTextArea}/>
        
        <div className="col-lg-5" style={{float:'left'}}>
          <div className="xs-copy-ptsans text-left">
          {!message.attachment && (
            <Dropzone className={classes.attachFileLabel} onDrop={handleAttachFile}>
              
            </Dropzone>
          )}
           
          </div>
         <div className={classes.letterAttachments}>
           {message.attachment && (
            <Carousel
              initialSlideWidth={400}
              renderCenterRightControls={({ previousSlide, nextSlide }) =>
                message.attachment.length > 1 ? (
                  <div className={classes.carouselControls}>
                    <KeyboardArrowLeft onClick={previousSlide} />
                    <KeyboardArrowRight onClick={nextSlide} />
                  </div>
                ) : (
                  false
                )
              }
              renderCenterLeftControls={() => false}
              renderBottomCenterControls={() => false}
            >
              {message.attachment.map(item => (
                <div className={classes.attachmentItem} key={item.size.toString()}>
                  <Typography className={classes.attachmentType}>
                    {getFileType(item.type)}
                  </Typography>
                  <div className={classes.attachNameSizeWrap}>
                    <Typography className={classes.attachInfo}>{item.name}</Typography>
                    <Typography className={classes.attachInfoSize}>
                      {item.size / 1000}
                      KB
                    </Typography>
                  </div>
                  <IconButton onClick={removeAttachments}>
                    <DeleteIcon className={classes.deleteIcon} />
                  </IconButton>
                </div>
              ))}
            </Carousel>
          )}
        </div>
          {/* {messageContent.message.data.attachments.map(item => (
                  <div
                    className={classes.attachmentItem}
                    key={item.id}
                    onClick={() => handlePopupToggle(item)}
                  >
                    <Typography className={classes.attachmentType}>
                      {getFileType(item.type)}
                    </Typography>
                    <div className={classes.attachNameSizeWrap}>
                      <Typography className={classes.attachInfo}>{item.name}</Typography>
                    </div>
                  </div>
          ))} */}
        </div>
        <MDBBtn className="col-lg-3 noShadow" size="md" color="grey-lighten"  onClick={()=>{
          setViewMessage(false);
          resetSelectionMessage();
          messagesListRequest();
          messageSendRequest()
          }}>
            Cancel
        </MDBBtn>
        <MDBBtn className="col-lg-3 noShadow" size="md" color="success" onClick={handleSend}>
            Send
        </MDBBtn>
        
        
      </MDBCardBody>
      
     </MDBCard>
    // <div className={classes.newMessage}>
    //   <div className={classes.messageHeader}>
    //     <Typography className={classes.messageTitle}>New Message</Typography>
    //     <IconButton className={classes.close} onClick={() => toggleComposeMessage(false)} />
    //   </div>
    //   <FormControl className={classes.formControl}>
    //     <InputLabel style={{ color: 'grey' }} htmlFor="age-simple">
    //       TO
    //     </InputLabel>
    //     <Select value={sendTo} onChange={handlePickSendTo} className={classes.select}>
    //       {connectedUsers.users &&
    //         connectedUsers.users.map(user => (
    //           <MenuItem
    //             key={user.userId}
    //             value={user.userId}
    //             style={{
    //               color: 'grey',
    //               background: '#212121',
    //               marginTop: -8,
    //               marginBottom: -8,
    //             }}
    //           >
    //             {`${user.firstname} ${user.lastname}`}
    //           </MenuItem>
    //         ))}
    //     </Select>
    //   </FormControl>
    //   <div className={classes.messageBody}>
    //     <Divider className={classes.divider} />
    //     <div className={classes.subjectField}>
    //       <TextField
    //         id="with-placeholder"
    //         label={<span style={{ color: 'grey' }}>Subject</span>}
    //         className={classes.textField}
    //         InputProps={{
    //           disableUnderline: true,
    //           className: classes.textField,
    //         }}
    //         value=""
    //       />
    //     </div>
    //     <Divider className={classes.divider} />
    //     <TextField
    //       id="textarea"
    //       placeholder="Type your message..."
    //       multiline
    //       className={classes.textArea}
    //       InputProps={{
    //         disableUnderline: true,
    //         className: classes.textField,
    //       }}
    //       onChange={handleTextArea}
    //     />
    //     <div className={classes.letterAttachments}>
    //       {message.attachment && (
    //         <Carousel
    //           initialSlideWidth={400}
    //           renderCenterRightControls={({ previousSlide, nextSlide }) =>
    //             message.attachment.length > 1 ? (
    //               <div className={classes.carouselControls}>
    //                 <KeyboardArrowLeft onClick={previousSlide} />
    //                 <KeyboardArrowRight onClick={nextSlide} />
    //               </div>
    //             ) : (
    //               false
    //             )
    //           }
    //           renderCenterLeftControls={() => false}
    //           renderBottomCenterControls={() => false}
    //         >
    //           {message.attachment.map(item => (
    //             <div className={classes.attachmentItem} key={item.size.toString()}>
    //               <Typography className={classes.attachmentType}>
    //                 {getFileType(item.type)}
    //               </Typography>
    //               <div className={classes.attachNameSizeWrap}>
    //                 <Typography className={classes.attachInfo}>{item.name}</Typography>
    //                 <Typography className={classes.attachInfoSize}>
    //                   {item.size / 1000}
    //                   KB
    //                 </Typography>
    //               </div>
    //               <IconButton onClick={removeAttachments}>
    //                 <DeleteIcon className={classes.deleteIcon} />
    //               </IconButton>
    //             </div>
    //           ))}
    //         </Carousel>
    //       )}
    //     </div>
    //     <div className={classes.messageFooterWrapper}>
    //       {!message.attachment && (
    //         <Dropzone className={classes.attachFileLabel} onDrop={handleAttachFile}>
    //           <IconButton
    //             style={{
    //               top: -13,
    //               left: -19,
    //             }}
    //           />
    //         </Dropzone>
    //       )}
    //       <Divider className={classes.divider} />
    //       <div className={classes.buttonWrapper}>
    //         <Button
    //           className={`${classes.defaultButton} ${classes.messageButtonSend}`}
    //           variant="raised"
    //           disabled={isDisabled}
    //           onClick={handleSend}
    //         >
    //           Send
    //         </Button>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

MessageCompose.propTypes = {
  classes: PropTypes.instanceOf(Object),
  subjectField: PropTypes.string,
  textAreaField: PropTypes.string,
  toggleComposeMessage: PropTypes.func,
  sendTo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handlePickSendTo: PropTypes.func,
  connectedUsers: PropTypes.instanceOf(Object),
  handleTextArea: PropTypes.func,
  message: PropTypes.instanceOf(Object),
  removeAttachments: PropTypes.func,
  handleAttachFile: PropTypes.func,
  handleSend: PropTypes.func,
  messageTitle: PropTypes.string,
};

const styles = theme => ({
  ...commonStyles,
  select: {
    color: '#333',
    '&:before': {
      border: 'none',
    },
  },
  iconGrey:{
    color: '#C6C6C6 !important', 
    marginRight: 5, 
    fontSize:24,
    marginTop: 5,
  },
  formControl: {
    minWidth: 120,
    marginTop: 0,
    width: '100%',
    color: '#fff',
    fontSize: 12,
    textTransform: 'capitalize',
    fontWeight: theme.typography.fontWeightMedium,
  },
  label: {
    color: COLORS.lightGrey,
  },
  subjectField: {
    flexShrink: 0,
  },
  attachFileLabel: {
    transform: 'rotate(90deg)',
    background: `url(${attach}) no-repeat`,
    width: 18,
    height: 38,
    cursor: 'pointer',
    overflow: 'hidden',
  },
  buttonWrapper: {
    marginTop: 10,
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'center',
  },
  messageFooterWrapper: {
    textAlign: 'center',
    width: '100%',
  },
  textArea: {
    minHeight: 100,
    width: '100%',
    marginTop: 20,
    marginBottom: 20,
    overflow: 'hidden',
    flex: 1,
  },
  messageButtonSend: {
    width: 105,
  },
  newMessage: {
    position: 'relative',
    borderRadius: 0,
    boxSizing: 'border-box',
    background: '#fff',
    padding: '20px',
    overflow: 'auto',
    flex: 2,
    width: 'calc(100% - 4px)',
    boxShadow: `0 0 0 2px ${COLORS.cornerstoneRed}`,
    margin: '2px 0',
    display: 'flex',
    flexDirection: 'column',
  },
  messageBody: {
    color: '#fff',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  textField: {
    color: COLORS.darkGrey,
    marginTop: 10,
    width: '100%',
  },
});

const mapStateToProps = state => ({
  messageDelete: state.messageDeleteReducer,
  messageContent: state.messageContentReducer,
  connectedUsers: state.connectedUsersReducer,
  message: state.messageReducer,
});

const mapDispatchToProps = dispatch => ({
  
  messageSendRequest: messageContent => dispatch(messageSendRequest(messageContent)),
  addAttachment: attachment => dispatch(addAttachment(attachment)),
  toggleComposeMessage: flag => dispatch(toggleComposeMessage(flag)),
  connectedUsersRequest: () => dispatch(connectedUsersRequest()),
  selectRecipient: recipientId => dispatch(selectRecipient(recipientId)),
  toggleNotification: value => dispatch(toggleNotification(value)),
  removeAttachment: () => dispatch(removeAttachment()),
  resetMessage: () => dispatch(resetMessage()),
  messagesSentRequest: () => dispatch(messagesSentRequest()),
  messagesListRequest: () => dispatch(messagesListRequest()),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('sendTo', 'handleSendTo', ''),
  withState('subjectField', 'handleSubjectField', null),
  withState('textAreaField', 'handleTextAreaField', null),
  withState('attachment', 'handleAddAttachment', null),
  withHandlers({
    handlePickSendTo: props => event => {
      
      props.handleSendTo(event[0]);
      props.selectRecipient(
        props.connectedUsers.users.find(user => user.userId === event[0]),
      );
    },
    handleAttachFile: props => acceptedFile => {
      
      props.addAttachment(acceptedFile);
      props.handleAddAttachment(acceptedFile);
    },
    removeAttachments: props => () => {
      props.removeAttachment();
      props.handleAddAttachment(null);
    },
    handleSubject: props => value => {
      
      props.handleSubjectField(value);
    },
    handleTextArea: props => value => {
      
      props.handleTextAreaField(value);
    },
    handleSend: props => () => {
      props.messageSendRequest({
        subject: props.subjectField,
        message: props.textAreaField,
      });
    },
  }),
  lifecycle({
    componentWillMount() {
      //this.props.handleSubject(this.props.messageTitle);
      this.props.connectedUsersRequest()
    },
    componentWillReceiveProps(nextProps) {
      console.log('VVVVV', nextProps.message)
      if (nextProps.message.messageSent) {
        nextProps.toggleNotification({
          value: true,
          message: "Message Sent!",
          type: 'success',
        });
        nextProps.resetMessage()
       // nextProps.setViewMessage(false);
          
        nextProps.messagesListRequest();
        nextProps.messagesSentRequest();
        nextProps.messageSendRequest()
        nextProps.closeCompose(false);
      }
    },
  }),
  withStyles(styles),
)(MessageCompose);



// WEBPACK FOOTER //
// ./src/Components/MessageCompose.jsx